import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/Auth";
import RoomCard from '../components/RoomCard';
import { useSearchParams } from 'react-router-dom';
import { GetRoomsApi } from "../services/Api";
import './Home.css';
import Loader from "../components/Loader";


export default function Home() {

    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
   
    useEffect(() => {
        async function api(){
            try {
                setLoading(true);
                if (isAuthenticated()) {
                    await GetRoomsApi(searchParams).then(res => setRooms(res.data.rooms));
                }
            } catch (error) {
                console.log(error);
            }finally{
                setLoading(false);
            }
        }
        api();
    }, [searchParams])

    if (!isAuthenticated()) {
        //redirect user to login
        return <Navigate to="/login" />
    }

    return (<>
        {loading ? <Loader /> : rooms.length === 0 ? <div className="bodyBGPic text-center h2 my-0" style={{paddingTop: '200px', paddingBottom:"200px"}}>Not Found</div> :
        <div className="bg-body-secondary">
            <section id="rooms" className="container">
                <div className="row">
                    {rooms.map((room) => <RoomCard key={room._id} room={room} />)}
                </div>
            </section>
        </div>}
    </>
    )
}